import { AppState } from "store";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/button";
import { useDispatch } from "react-redux";
import { fetchMachineManuals } from "store/machineDetail/machineManuals/actions";
import Spinner from "components/spinner";
import Divider from "components/typography/heading/divider";
import Details from "components/machine/manuals/detail";
import { EModalTypes } from "store/manuals/types";
import CreateManuals from "components/machine/manuals/createManuals";
import actions from "store/manuals/actions";

const pageSize = 10;

const MachineManuals = ({
  machine,
  subcategory,
  company,
  project,
}: {
  machine: number;
  subcategory: number;
  company: number;
  project: number;
}) => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();

  const {
    manualsAttachment,
    isFetching,
    showMoreClickedTimesRef,
    attachmentParams: { page },
  } = useSelector((state: AppState) => state.machineDetail.machineManuals);
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    setOpen(!open);
  }, [open]);

  useEffect(() => {
    if (showMoreClickedTimesRef.current === null) {
      showMoreClickedTimesRef.current = 0;
    }
  }, [showMoreClickedTimesRef]);

  useEffect(() => {
    dispatch(
      fetchMachineManuals({
        id: machine,
        ps: pageSize,
        page,
      })
    );
  }, [dispatch, machine]);

  const initialState = useMemo(() => {
    return {
      pageIndex: page,
      pageSize,
      pageCount: manualsAttachment
        ? Math.ceil(manualsAttachment.count / pageSize)
        : 0,
    };
  }, [manualsAttachment, pageSize, page]);

  const onPageChange = (pageIndex: number) => {
    dispatch(
      fetchMachineManuals({
        id: machine,
        ps: pageSize,
        page: pageIndex,
      })
    );
  };

  return (
    <>
      {isFetching ? (
        <Spinner />
      ) : (
        <>
          <Divider line>{t("machine.detail.manualAttachment.header")}</Divider>
          <Details
            data={
              manualsAttachment && manualsAttachment.results.length
                ? manualsAttachment.results
                : []
            }
            loading={isFetching}
            initialState={initialState}
            onPageChange={onPageChange}
            rowsCount={
              manualsAttachment && manualsAttachment.results.length
                ? manualsAttachment.count
                : 0
            }
            showMoreClickedTimesRef={showMoreClickedTimesRef}
            isMachineDetail
          />
          <Button
            color="primary"
            onClick={openModal}
            id="addMachineManual"
            size="large"
          >
            {t("machine.detail.addAttachment")}
          </Button>

          {open ? (
            <CreateManuals
              open={open}
              closeModal={() => setOpen(false)}
              modelType={EModalTypes.create}
              machine={machine}
              isMachineDetail
              company={company ? [company] : undefined}
              subcategory={subcategory}
              project={project}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default MachineManuals;
